import AiAskBarComposerPanelBranch from './AiAskBarComposerPanelBranch'
import AiAskBarHomePanelBranch from './AiAskBarHomePanelBranch'

export default function AiAskBarRootPanels(props) {
  const { vm } = props
  if (vm.isComposerVariant) return <AiAskBarComposerPanelBranch {...props} />
  return <AiAskBarHomePanelBranch {...props} />
}
